import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LayoutDashboard, Coins, Mail, LogOut, ExternalLink } from "lucide-react";

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 border-l-2 transition-colors ${
      isActive
        ? "border-[#D4AF37] bg-[#D4AF37]/5 text-[#F3EFE0]"
        : "border-transparent text-[#A19D94] hover:text-[#F3EFE0] hover:bg-[#0A0A0A]"
    }`;

  return (
    <div className="min-h-screen bg-[#050505] text-[#F3EFE0] grid grid-cols-1 md:grid-cols-[260px_1fr]">
      <aside className="border-r border-[#F3EFE0]/10 bg-[#0A0A0A] flex flex-col">
        <div className="p-6 border-b border-[#F3EFE0]/10">
          <Link to="/admin" className="flex items-center gap-2" data-testid="admin-logo">
            <Coins className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
            <span className="font-display text-xl">Cornett</span>
          </Link>
          <div className="coin-tag mt-1 text-[#6B6A65]">Control Room</div>
        </div>
        <nav className="py-4 flex flex-col">
          <NavLink to="/admin" end className={linkCls} data-testid="sidebar-dashboard">
            <LayoutDashboard className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-sm">Dashboard</span>
          </NavLink>
          <NavLink to="/admin/coins" className={linkCls} data-testid="sidebar-coins">
            <Coins className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-sm">Coins</span>
          </NavLink>
          <NavLink to="/admin/inquiries" className={linkCls} data-testid="sidebar-inquiries">
            <Mail className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-sm">Inquiries</span>
          </NavLink>
        </nav>
        <div className="mt-auto p-4 border-t border-[#F3EFE0]/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-2 text-xs text-[#A19D94] hover:text-[#D4AF37]" data-testid="view-public-site">
            <ExternalLink className="w-3.5 h-3.5" strokeWidth={1.5} />
            View Public Site
          </Link>
          <div className="text-xs text-[#6B6A65]">{user?.email}</div>
          <button onClick={onLogout} className="flex items-center gap-2 text-xs text-[#A19D94] hover:text-[#D4AF37]" data-testid="logout-btn">
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} />
            Sign Out
          </button>
        </div>
      </aside>
      <main className="p-6 md:p-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
